import { NotFound } from "@app/shared/ErrorPages";
import { Roles, UserContext } from "@app/user";
import { FC, useContext } from "react";
import { Route, Switch } from "react-router-dom"
import EnterpriseComplianceDashboard from "./enterprise-compliance-dashboard/EnterpriseComplianceDashboard";
import { FeatureFlagContext, Features } from "@app/feature-flags";
import { BenchmarkingDashboard } from "@app/overviews/network-benchmarking-dashboard";
import EcdReportGenerationWizard from "./enterprise-compliance-dashboard/EcdReportGenerationWizard";

const OverviewsRouter: FC = () => {
  const user = useContext(UserContext);
  const featureFlags = useContext(FeatureFlagContext).enabledFeatureFlags;

  if (!user) {
    return <NotFound />;
  }

  return (
    <Switch>
      {(user.roles.includes(Roles.ENTERPRISE_COMPLIANCE_DASHBOARD_USER) && featureFlags.has(Features.ECD_REPORT_ENHANCEMENT))  ? (
        <Route path="/overviews/enterprise-compliance-dashboard/generate-report" component={EcdReportGenerationWizard} />
      ) : (
        null
      )}

      {(user.roles.includes(Roles.ENTERPRISE_COMPLIANCE_DASHBOARD_USER)) ? (      
        <Route path="/overviews/enterprise-compliance-dashboard" component={EnterpriseComplianceDashboard} />
      ) : (
        null
      )}

      {(user.roles.includes(Roles.COMPETITIVE_INSIGHTS_USER) && featureFlags.has(Features.NETWORK_BENCHMARKING)) ? (
        <Route path="/overviews/competitive-insights-dashboard" component={BenchmarkingDashboard} />
      ) : (
        null
      )}

      <Route component={NotFound} />
    </Switch>
  );
};

export default OverviewsRouter;